const loading = {
    markingWords: "markingWords",
    updateAsssessmentStatus: "updateAsssessmentStatus",
    createAssessmentWithFile: "createAssessmentWithFile",
    printAssessment:"printAssessment"
}

export default loading